import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { CommonVariablesService } from '../../common-variables.service';

@Component({
  selector: 'app-vessel-exposure-report',
  templateUrl: './vessel-exposure-report.component.html',
})
export class VesselExposureReportComponent implements OnInit {
  vesselExposureReportForm: FormGroup;
  systemDate: any;
  declarationPunched: any;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  tblData: any;
  fetchUrl: string;
  submitted = false;
  getsystemDate: any;
  getFromDate: any;
  fromDate: any;
  toDate: any;
  sendFromDate: any;
  sendToDate: any;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
	window.localStorage.setItem('pageName','');
    $('#btnVesselExposureReportExcelDownload').hide();
    $('#divVesselExposureReport').hide();

    this.fetchUrl = this.commonVariablesService['baseURL'] + 'api/v1/marine_report/fetch_vessel_exposure';
    this.vesselExposureReportForm = this.formBuilder.group({
      txtFromDate: ['', Validators.required],
      txtToDate: ['', Validators.required],
      txtVesselName: ['', Validators.required],
      txtBranchLocation: ['']
    });

    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };

  }

  /*******************************************
  * Created By : Dinesh kumar
  * Description : Used to get form controls.
  ********************************************/
  get f() { return this.vesselExposureReportForm.controls; }

  /****************************************************************
  * Created By : Dinesh kumar
  * Description : Used to show data against from date and to date.
  *****************************************************************/
  async submitDate() {
    if (this.vesselExposureReportForm.invalid) {
      this.submitted = true;
      return;
    }
    else {
      this.fromDate = this.datePipe.transform(this.vesselExposureReportForm.value.txtFromDate);
      this.toDate = this.datePipe.transform(this.vesselExposureReportForm.value.txtToDate);

      if (new Date(this.toDate) < new Date(this.fromDate)) {
        this.commonService.errorsmsg("From date should be less than to date", "Error");
      }
      else {
        this.spinner.show();
        $('#searchCertificateNo,#searchPolicyNo,#searchBranchLocation,#searchInsuredName,#searchProducerName,#searchVoyage,#searchVesselName,#searchSubjectMatterInsured,#searchTotalSumInsured,#searchAirwayBillNo,#searchAirwayBillDate,#searchInvoiceNumber,#searchInvoiceDate,#searchExpectedDateOfShipment').val('');
        let table = $('#tblVesselExposureReport').DataTable();
        table.destroy();
        this.tblData = [];
        this.sendFromDate = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
        this.sendToDate = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');

        let param = new HttpParams().set('from_date', this.sendFromDate)
          .set('to_date', this.sendToDate)
          .set('branch_location', this.vesselExposureReportForm.value.txtBranchLocation)
          .set('vessel_name', this.vesselExposureReportForm.value.txtVesselName)
        let responseData = await this.commonService.httpGetMethod(this.fetchUrl, 'application/x-www-form-urlencoded', true, param, 'User Report');

        if (responseData.status == 0) {
          for (var i = 0; i < responseData.data.length; i++) {
			  var data = responseData.data[i].total_sum_insured;
			  var lastVal = responseData.data[i].total_sum_insured.substr(-5)
				var len = (data.length) - 5;
				var val: number = +data.slice(0,len);
			  responseData.data[i].total_sum_insured = Math.floor(val)+lastVal
            this.tblData.push(responseData.data[i]);
          }
        }
        else if (responseData.status != -114) {
          this.commonService.errorsmsg('Fetch Error: ' + responseData.txt, "Error");
        }

        this.dtTrigger.next();

        $('#btnVesselExposureReportExcelDownload').show();
        $('#divVesselExposureReport').show();
      }
    }
  }

  /***************************************
  * Created By : Dinesh kumar
  * Description : Used to download excel.
  ****************************************/
  exportExcel() {
    var tmpObj = {};
    var tmpArray = [];
    if (this.tblData.length > 0) {
      for (var i = 0; i < this.tblData.length; i++) {
        tmpObj = {};
        tmpObj['certificate_no'] = this.tblData[i].certificate_no;
        tmpObj['policy_no'] = this.tblData[i].policy_no;
        tmpObj['branch_location'] = this.tblData[i].branch_location;
        tmpObj['insured_name'] = this.tblData[i].insured_name;
        tmpObj['producer_name'] = this.tblData[i].producer_name;
        tmpObj['voyage_name'] = this.tblData[i].voyage_name;
        tmpObj['vessel_name'] = this.tblData[i].vessel_name;
        tmpObj['subject_matter_issued'] = this.tblData[i].subject_matter_issued;
        tmpObj['total_sum_insured'] = this.tblData[i].total_sum_insured;
        tmpObj['bill_of_landing_no'] = this.tblData[i].bill_of_landing_no;
        tmpObj['bill_of_lading_date'] = this.tblData[i].bill_of_lading_date;
        tmpObj['invoice_number'] = this.tblData[i].invoice_number;
        tmpObj['invoice_date'] = this.tblData[i].invoice_date;
        tmpObj['expected_date_of_shipment'] = this.tblData[i].expected_date_of_shipment;
        tmpObj['issue_date'] = this.tblData[i].issue_date;

        tmpArray.push(tmpObj)
      }
      var datajson = { datajson1: tmpArray };

      var Heading = [
        [],
        ["Vessel Exposure Report"],
        [],
        ["From Date", this.datePipe.transform(this.vesselExposureReportForm.value.txtFromDate, 'dd-MM-yyyy') || ''],
        ["To Date", this.datePipe.transform(this.vesselExposureReportForm.value.txtToDate, 'dd-MM-yyyy') || ''],
        ["Vessel Name or Flight No/Airline", this.vesselExposureReportForm.value.txtVesselName || ''],
        ["Branch Location", this.vesselExposureReportForm.value.txtBranchLocation || ''],
        [],
        ["Certificate Number / Draft Number", "Policy Number", "Branch Location", "Insured Name", "Producer Name", "Voyage", "Vessel Name or Flight Number/Airline Number", "Subject Matter Insured", "Total Sum Insured", "Bill of Lading Number/Airway Bill Number", "Bill of Lading Date/Airway Bill Date", "Invoice Number", "Invoice Date", "Expected date of shipment", "Issue Date"]
      ];

      const merge = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 13 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 13 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 13 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 13 } },
        { s: { r: 8, c: 0 }, e: { r: 8, c: 13 } }
      ];
      var wscols = [];
      for (let idx = 0; idx < Heading[8].length; idx++) {
        wscols.push({ wch: 25 });  // Common column width
      }
      var ws = XLSX.utils.json_to_sheet(Heading);
      ws['!cols'] = wscols;
      ws["!merges"] = merge;
      ws["A1"] = {
        "t": 's',
        /* "v": 'TATA MARINE', */
      };

      XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
        header: ["certificate_no", "policy_no", "branch_location", "insured_name", "producer_name", "voyage_name", "vessel_name", "subject_matter_issued", "total_sum_insured", "bill_of_landing_no", "bill_of_lading_date", "invoice_number", "invoice_date", "expected_date_of_shipment", "issue_date"],
        skipHeader: true,
        origin: -1
      });

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Vessel Exposure Report");
      XLSX.writeFile(wb, 'Vessel_Exposure_Report.xlsx');
    }
    else {
      this.commonService.errorsmsg("Unable to download excel,No data available in the table", "Error");
    }
  }

  /**********************************************
  * Created By : Keerthana
  * Description : Used to do search in datatable.
  ***********************************************/
  filterBySearch() {
    let searchCertificateNo = $("#searchCertificateNo").val().toString().toLowerCase();
    let searchPolicyNo = $("#searchPolicyNo").val().toString().toLowerCase();
    let searchBranchLocation = $("#searchBranchLocation").val().toString().toLowerCase();
    let searchInsuredName = $("#searchInsuredName").val().toString().toLowerCase();
    let searchProducerName = $("#searchProducerName").val().toString().toLowerCase();
    let searchVoyage = $("#searchVoyage").val().toString().toLowerCase();
    let searchVesselName = $("#searchVesselName").val().toString().toLowerCase();
    let searchSubjectMatterInsured = $("#searchSubjectMatterInsured").val().toString().toLowerCase();
    let searchTotalSumInsured = $("#searchTotalSumInsured").val().toString().toLowerCase();
    let searchAirwayBillNo = $("#searchAirwayBillNo").val().toString().toLowerCase();
    let searchAirwayBillDate = $("#searchAirwayBillDate").val().toString().toLowerCase();
    let searchInvoiceNumber = $("#searchInvoiceNumber").val().toString().toLowerCase();
    let searchInvoiceDate = $("#searchInvoiceDate").val().toString().toLowerCase();
    let searchExpectedDateOfShipment = $("#searchExpectedDateOfShipment").val().toString().toLowerCase();
    let searchIssueDate = $("#searchIssueDate").val().toString().toLowerCase();

    let table = $("#tblVesselExposureReport").DataTable();
    table.search('').columns().search('').draw();
    if (searchCertificateNo != "") {
      table.column(0).search(searchCertificateNo).draw();
    }
    if (searchPolicyNo != "") {
      table.column(1).search(searchPolicyNo).draw();
    }
    if (searchBranchLocation != "") {
      table.column(2).search(searchBranchLocation).draw();
    }
    if (searchInsuredName != "") {
      table.column(3).search(searchInsuredName).draw();
    }
    if (searchProducerName != "") {
      table.column(4).search(searchProducerName).draw();
    }

    if (searchVoyage != "") {
      table.column(5).search(searchVoyage).draw();
    }
    if (searchVesselName != "") {
      table.column(6).search(searchVesselName).draw();
    }
    if (searchSubjectMatterInsured != "") {
      table.column(7).search(searchSubjectMatterInsured).draw();
    }
    if (searchTotalSumInsured != "") {
      table.column(8).search(searchTotalSumInsured).draw();
    }
    if (searchAirwayBillNo != "") {
      table.column(9).search(searchAirwayBillNo).draw();
    }
    if (searchAirwayBillDate != "") {
      table.column(10).search(searchAirwayBillDate).draw();
    }
    if (searchInvoiceNumber != "") {
      table.column(11).search(searchInvoiceNumber).draw();
    }
    if (searchInvoiceDate != "") {
      table.column(12).search(searchInvoiceDate).draw();
    }
    if (searchExpectedDateOfShipment != "") {
      table.column(13).search(searchExpectedDateOfShipment).draw();
    }
    if (searchIssueDate != "") {
      table.column(14).search(searchIssueDate).draw();
    }
  }

}
